import React from "react"
import styled from "styled-components"
import { LinkBox } from "Components"
import LinkedInIcon from "Static/icons/linkedin.svg"
import { BrandedColor, Speakers } from "Styles"
import { theme } from "Theme"

const Wrapper = styled.section`
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem 1rem;
  @media (min-width: ${theme.breakpoints.s}) {
    padding: 2rem;
  }

  @media (min-width: ${theme.breakpoints.m}) {
    flex-direction: column;
    margin: 0;
    padding: 2rem;
    width: 100%;
  }

  @media (min-width: ${theme.breakpoints.l}) {
    margin: 0 auto 0;
  }
  max-width: ${theme.layout.base};
`

const Content = styled.div`
  display: block;
  margin: 0 auto;
  text-align: left;
  width: 100%;
  background-color: ${(props) => (props.dark ? theme.colors.black.base : theme.colors.white.base)};
  color: ${(props) => (props.dark ? theme.colors.white.base : theme.colors.black.base)};
  border-color: ${(props) => (props.dark ? theme.colors.white.base : theme.colors.black.base)};
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const Grid = styled.div`
  margin: 1rem auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(40%, 1fr));
  @media (min-width: ${theme.breakpoints.s}) {
    grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));
  }
  @media (min-width: ${theme.breakpoints.m}) {
    grid-template-columns: repeat(auto-fill, minmax(20%, 1fr));
  }
  @media (min-width: ${theme.breakpoints.l}) {
    grid-template-columns: repeat(auto-fill, minmax(15%, 1fr));
  }
  grid-gap: 16px;
`

const Title = styled.h2`
  color: inherit;
  font-weight: bold;
  max-width: ${theme.layout.base};
  margin-left: auto;
  margin-right: auto;
  text-align: left;
`

const SectionTeam = ({ moderator, keynote, title }) => (
  <>
    <Wrapper>
      <Content>
        <Title>
          <BrandedColor>{title}</BrandedColor>
        </Title>
        <Grid>
          {moderator && keynote && moderator.linkedin_link == keynote.linkedin_link ? (
            <div>
              <h5>Moderator & Keynote</h5>

              <Speakers.Card>
                <LinkBox
                  to={keynote.linkedin_link ? keynote.linkedin_link : ""}
                  track={"Speakers"}
                  title={`${keynote.firstName} ${keynote.lastName}`}>
                  <Speakers.Avatar
                    background={keynote.image}
                    alt={`${keynote.firstName} ${keynote.lastName} - ${keynote.title} at ${keynote.company_name}`}
                    title={`${keynote.firstName} ${keynote.lastName} - ${keynote.title} at ${keynote.company_name}`}>
                    {keynote.linkedin_link && <Speakers.Icon src={LinkedInIcon} />}
                    <Speakers.Name>{`${keynote.firstName} ${keynote.lastName}`}</Speakers.Name>
                  </Speakers.Avatar>
                </LinkBox>
                <Speakers.Content>
                  <Speakers.Details>
                    <Speakers.Title>{`${keynote.title}`}</Speakers.Title>
                    <Speakers.Company>{`${keynote.company_name}`}</Speakers.Company>
                  </Speakers.Details>
                </Speakers.Content>
              </Speakers.Card>
            </div>
          ) : (
            <>
              {moderator && (
                <div>
                  <h5>Moderator</h5>
                  <Speakers.Card>
                    <LinkBox
                      to={moderator.linkedin_link ? moderator.linkedin_link : ""}
                      track={"Speakers"}
                      title={`${moderator.firstName} ${moderator.lastName}`}>
                      <Speakers.Avatar
                        background={moderator.image}
                        alt={`${moderator.firstName} ${moderator.lastName} - ${moderator.title} at ${moderator.company_name}`}
                        title={`${moderator.firstName} ${moderator.lastName} - ${moderator.title} at ${moderator.company_name}`}>
                        {moderator.linkedin_link && <Speakers.Icon src={LinkedInIcon} />}
                        <Speakers.Name>{`${moderator.firstName} ${moderator.lastName}`}</Speakers.Name>
                      </Speakers.Avatar>
                    </LinkBox>
                    <Speakers.Content>
                      <Speakers.Details>
                        <Speakers.Title>{`${moderator.title}`}</Speakers.Title>
                        <Speakers.Company>{`${moderator.company_name}`}</Speakers.Company>
                      </Speakers.Details>
                    </Speakers.Content>
                  </Speakers.Card>
                </div>
              )}
              {keynote && (
                <div>
                  <h5>Keynote</h5>
                  <Speakers.Card>
                    <LinkBox
                      to={keynote.linkedin_link ? keynote.linkedin_link : ""}
                      track={"Speakers"}
                      title={`${keynote.firstName} ${keynote.lastName}`}>
                      <Speakers.Avatar
                        background={keynote.image}
                        alt={`${keynote.firstName} ${keynote.lastName} - ${keynote.title} at ${keynote.company_name}`}
                        title={`${keynote.firstName} ${keynote.lastName} - ${keynote.title} at ${keynote.company_name}`}>
                        {keynote.linkedin_link && <Speakers.Icon src={LinkedInIcon} />}
                        <Speakers.Name>{keynote.name}</Speakers.Name>
                      </Speakers.Avatar>
                    </LinkBox>
                    <Speakers.Content>
                      <Speakers.Details>
                        <Speakers.Title>{`${keynote.title}`}</Speakers.Title>
                        <Speakers.Company>{`${keynote.company_name}`}</Speakers.Company>
                      </Speakers.Details>
                    </Speakers.Content>
                  </Speakers.Card>
                </div>
              )}
            </>
          )}
        </Grid>
      </Content>
    </Wrapper>
  </>
)

export default SectionTeam
